const UNIT_MINUTES = Object.freeze({ minutes: 1, hours: 60, days: 1440 });

export function formatReminderOffset(minutes) {
  if (minutes % 1440 === 0) {
    const days = minutes / 1440;
    return `${days} ${days === 1 ? "day" : "days"}`;
  }
  if (minutes % 60 === 0) {
    const hours = minutes / 60;
    return `${hours} ${hours === 1 ? "hour" : "hours"}`;
  }
  return `${minutes} minutes`;
}

export function customTimingToMinutes(amount, unit) {
  const numericAmount = Number(amount);
  if (!Number.isInteger(numericAmount) || numericAmount <= 0 || !UNIT_MINUTES[unit]) {
    return null;
  }
  return numericAmount * UNIT_MINUTES[unit];
}
